module.exports = __webpack_public_path__ + "static/media/clear-day.5dd8285a.svg";